// project imports
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';
import {
    processEntityInput as processEntityInputSafeDeleter,
    processEntityOutput as processEntityOutputSafeDeleter
} from 'store/serializers/fragments/safe-deleter';
import { getIdFromObj, getIriFromObj } from 'utils/processors';
import {
    processEntityInput as processEntityInputExecSettings,
    processEntityOutput as processEntityOutputExecSettings
} from 'store/app/workmgmt/exec-settings';
import {
    processEntityInput as processEntityInputFollowUp,
    processEntityOutput as processEntityOutputFollowUp
} from 'store/app/workmgmt/followup';
import { processEntityInput as processEntityInputNote, processEntityOutput as processEntityOutputNote } from 'store/app/workmgmt/note';
import { sortTasksByParentPosition } from './tree';

const hasFollowUpData = (values) =>
    Boolean(values) &&
    ['@id', '@type', 'id', 'name', 'description', 'task', 'state', 'previousState', 'currentStep', 'tplReference', 'steps'].some(
        (key) => key in values
    );

const getTaskIri = (value) => {
    const iri = getIriFromObj(value);
    if (iri) {
        return iri;
    }

    const id = getIdFromObj(value);
    if (id !== undefined && id !== null && `${id}`.trim()) {
        return `/workmgmt/tasks/${id}`;
    }

    return null;
};

export function processEntityInput(values) {
    return {
        ...values,
        ...processEntityInputMain(values),
        ...processEntityInputSafeDeleter(values),
        children:
            'children' in (values || {}) && Array.isArray(values?.children)
                ? sortTasksByParentPosition(values.children.map((child) => processEntityInput(child)))
                : undefined,
        execSettings: processEntityInputExecSettings(values?.execSettings),
        followUp: 'followUp' in (values || {}) && hasFollowUpData(values?.followUp) ? processEntityInputFollowUp(values?.followUp) : null,
        notes: values?.notes?.map((note) => processEntityInputNote(note))?.sort((n1, n2) => (n1.createdAt < n2.createdAt ? 1 : -1))
    };
}

export const processEntityOutput = (values) => {
    let followUp;

    if ('followUp' in (values || {})) {
        followUp = hasFollowUpData(values?.followUp) ? processEntityOutputFollowUp(values?.followUp) : null;
    }

    return {
        ...values,
        ...processEntityOutputMain(values),
        ...processEntityOutputSafeDeleter(values),
        id: undefined,
        metadata: undefined,
        path: undefined,
        level: undefined,
        root: undefined,
        children: undefined,
        parent: 'parent' in (values || {}) ? getTaskIri(values.parent) : undefined,
        positionByParent: 'positionByParent' in (values || {}) ? values?.positionByParent ?? null : undefined,
        businessOpportunity: 'businessOpportunity' in (values || {}) ? getIriFromObj(values.businessOpportunity) : undefined,
        workOrder: 'workOrder' in (values || {}) ? getIriFromObj(values.workOrder) : undefined,
        responsible: 'responsible' in (values || {}) ? getIriFromObj(values.responsible) : undefined,
        participants:
            'participants' in (values || {}) && Array.isArray(values.participants)
                ? values.participants.map((part) => getIriFromObj(part) || null)
                : undefined,
        contacts:
            'contacts' in (values || {}) && Array.isArray(values.contacts)
                ? values.contacts.map((contact) => getIriFromObj(contact) || null)
                : undefined,
        execSettings: processEntityOutputExecSettings(values?.execSettings),
        followUp,
        notes:
            'notes' in (values || {}) && Array.isArray(values.notes)
                ? values.notes.map((note) => processEntityOutputNote(note))
                : undefined,
        tickets:
            'tickets' in (values || {}) && Array.isArray(values.tickets)
                ? values.tickets.map((ticket) => getIriFromObj(ticket) || null)
                : undefined
    };
};
